<script setup=""></script>

<template>
  <svg fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.0001 11.7781C13.7178 11.7781 11.7778 13.718 11.7778 16.0003C11.7778 18.2826 13.7178 20.2225 16.0001 20.2225C18.2823 20.2225 20.2223 18.2826 20.2223 16.0003C20.2223 13.718 18.2823 11.7781 16.0001 11.7781Z"
      fill="currentColor"
    />
    <path
      d="M21.412 3.33325H10.7029C6.55749 3.33325 3.33325 6.55749 3.33325 10.5878V21.2969C3.33325 25.4423 6.55749 28.6666 10.7029 28.6666H21.412C25.4423 28.6666 28.6666 25.4423 28.6666 21.2969V10.5878C28.6666 6.55749 25.4423 3.33325 21.412 3.33325ZM15.9999 22.6787C12.3151 22.6787 9.43628 19.6848 9.43628 16.1151C9.43628 12.5454 12.3151 9.43628 15.9999 9.43628C19.6848 9.43628 22.5636 12.4302 22.5636 15.9999C22.5636 19.5696 19.6848 22.6787 15.9999 22.6787ZM22.7939 10.8181C21.9878 10.8181 21.2969 10.1272 21.2969 9.32113C21.2969 8.51507 21.9878 7.82416 22.7939 7.82416C23.5999 7.82416 24.2908 8.51507 24.2908 9.32113C24.2908 10.1272 23.5999 10.8181 22.7939 10.8181Z"
      fill="currentColor"
    />
  </svg>
</template>
